<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    New Form
</h1>
<form>
    <div mat-dialog-content id="matDialogContent">
        <mat-form-field *ngIf="!OpenedFromHomePage" appearance="outline" [floatLabel]="'always'" class="mat-select-mat-form-field">
            <mat-label>Form Template:</mat-label>
            <mat-select name="SelectedFormId"
                        [(ngModel)]="this.selectedFormId"
                        (ngModelChange)="this.handleNgModelChange('form')">
                <mat-option [value]="0">Select a Form Template</mat-option>
                <mat-option *ngFor="let form of this.siteForms" [value]="form.id">
                    {{form.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!--
        <mat-form-field *ngIf="OpenedFromHomePage" appearance="outline" [floatLabel]="'always'" class="mat-select-mat-form-field">
            <mat-label>Destination Folder:</mat-label>
            <mat-select name="DestinationFolderId"
                        [(ngModel)]="this.destinationFolderId"
                        (ngModelChange)="this.handleNgModelChange('destination-folder-control')">
                <mat-option [value]="0">Select a Destination Folder</mat-option>
                <mat-option *ngFor="let folder of WriteableFolders" [value]="folder.id">
                    {{folder.name}} ({{folder.id}})
                </mat-option>
            </mat-select>
        </mat-form-field>
        -->

        <mat-form-field *ngIf="OpenedFromHomePage" appearance="outline" [floatLabel]="'always'" class="mat-select-mat-form-field">
            <mat-label>Destination Folder</mat-label>
            <input type="text"
                   [formControl]="destFolderFormControl"
                   placeholder="Select/Start Typing..."
                   matInput
                   [matAutocomplete]="autoComplete"
                   />
            <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="displayFolderPath">
                <mat-option *ngFor="let folder of filteredWriteableFolders | async" [value]="folder">
                    {{folder.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <br />

        <mat-form-field appearance="outline" class="form-name-mat-form-field">
            <mat-label>Form Name:</mat-label>
            <input matInput
                   [(ngModel)]="this.formInstanceName"
                   (ngModelChange)="this.handleNgModelChange('form-instance')"
                   [readonly]="this.selectedFormId === 0 && this.destinationFolderId === 0"
                   placeholder="Form Name"
                   #formName
                   name="formName"
                   autocomplete="off"
                   required />
        </mat-form-field>

        <div *ngIf="ChildFolderCount > 1">
            <mat-label>Add to:</mat-label> &nbsp;
            <mat-radio-group aria-label="Location" name="addLocationRadio" [(ngModel)]="this.addLocation">
                <mat-radio-button checked="true" value="here">This Folder</mat-radio-button> &nbsp;
                <mat-radio-button value="subfolders">All Subfolders</mat-radio-button>
            </mat-radio-group>
        </div>

    </div>

    <div mat-dialog-actions id="matDialogActions">
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="(this.formInstanceName === null) || (this.formInstanceName.trim() === '')"
                (click)="this.createClicked()">
            Create
        </button>

        <button mat-flat-button
                [mat-dialog-close]="null"
                style="margin-left: 10px;">
            Cancel
        </button>
    </div>
</form>
